import { useHistory, useParams } from "react-router-dom";
import { Card } from "../../../components/card.component";
import { AppRouteUi } from "../../../config/appRoute";
import { UpdateAppointment } from "../../../features/appointment/updateAppointment.component";
import { ApiAppointment } from "../../../core/apis/appointment";
import { UtilityDate } from "../../../utils/dateUtils";
import { useEffect, useState } from "react";
import { ApiSchemaAppointmentById } from "../../../models/api/appointment";

export const PageAppointmentUpdate = () => {
  const { appointmentId } = useParams<{ appointmentId: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<ApiSchemaAppointmentById>();

  useEffect(() => {
    setIsLoading(true);
    ApiAppointment.GetById(appointmentId).then((appointment) => {
      setData(appointment);
      setIsLoading(false);
    });
  }, [appointmentId]);

  const routeHistory = useHistory();

  return (
    <Card
      header={
        <div className="row align-items-center justify-content-between">
          <div className="col content-box-title">
            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  routeHistory.length > 1
                    ? routeHistory.goBack()
                    : routeHistory.push(AppRouteUi.Root);
                }}
                className="pe-2 border-2 click text-green-200"
              >
                <i className="fas fa-arrow-left text-green-200" />
              </div>
              <div className="d-flex flex-column border-start">
                <p className="text-capitalize mb-0 ps-2  text-green-200">
                  Edit Appointment
                </p>
                {!isLoading && (
                  <p className="ms-2 pb-1 small-text">
                    ({UtilityDate.formatDate(data?.appointmentStartDate)},{" "}
                    {UtilityDate.formatTime(data?.taskStartTime)}, with{" "}
                    {`${data?.patientName}`})
                  </p>
                )}
              </div>
            </div>
            <div className="collapse-icon"></div>
          </div>
        </div>
      }
    >
      <UpdateAppointment
        data={data}
        isValidating={isLoading}
        appointmentId={appointmentId}
        showAvailableDays
      />
    </Card>
  );
};
